<div class="flex align-items-center align-content-center px-2 w-full">
  <mat-icon *ngIf="icon" class="material-symbols-outlined text-gray-700 mr-1">{{icon}}</mat-icon>
  <div *ngFor="let item of trees; let last = last; trackBy: trackByMenuItem" class="flex align-content-center">
    <span class="flex align-items-center justify-content-center text-xs font-light uppercase">
      {{ item.labelPage ?? item.label }}
    </span>
    <mat-icon *ngIf="!last" class="material-symbols-outlined text-gray-700">arrow_right</mat-icon>
  </div>
  <span *ngIf="info" class="ml-2 text-xs font-medium uppercase">
    {{ info }}
  </span>
</div>
